export const css = {
	oneaction: '_2HNUOQjM',
	' _key': 'afcpe-theme/afcpe/quiz-widgets/flashcard'
};

export default css;
